/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Chat_Error_UnknownInputs */

const en_chat_error_unknown = /** @type {(inputs: Chat_Error_UnknownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const fr_chat_error_unknown = /** @type {(inputs: Chat_Error_UnknownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur : ${i?.message}`)
};

const ms_sg2_chat_error_unknown = /** @type {(inputs: Chat_Error_UnknownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ralat: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Error: {message}" |
*
* @param {Chat_Error_UnknownInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_error_unknown = /** @type {((inputs: Chat_Error_UnknownInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_UnknownInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_error_unknown(inputs)
	if (locale === "fr") return fr_chat_error_unknown(inputs)
	return ms_sg2_chat_error_unknown(inputs)
});